import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {User} from '../../../model/user/User';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState} from '../../../store/app.states';
import {LogIn} from '../../../store/actions/auth.actions';
import {Observable} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {PingService} from '../../../services/ping.service';
import { controllers } from 'chart.js';
import { stringify } from 'querystring';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  notFocused = false;
  submitted: boolean;
  show = false;
  title = 'IBD Tool';

  user: User;
  getState: Observable<any>;
  errorMessage: string | null;

  returnUrl: string;

  constructor(private authService: AuthService,
              private router: Router,
              private store: Store<AppState>,
              public dialog: MatDialog,
              private pingService: PingService) {
    this.getState = this.store.select(selectAuthState);
  }

  ngOnInit(): void {
    this.pingService.ping();
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, this.myValidatorEmail]),
      password: new FormControl('', [Validators.required])
    });
    this.getState.subscribe((state) => {
      this.errorMessage = state.errorMessage;
    });
  }

  myValidatorEmail(control: FormControl) {
    if(control.value.includes("@") && control.value.includes(".")) 
      return null;
      else return {required: true}
   }

  

  onSubmit(login) {
    this.submitted = false;
    this.show = false;
    const val = login;
    //tolgo eventuali spazi, il controllo sulla correttezza l'ho fatto precedentemente
    var newMail = val.email.replace(/\s/g, "");
    newMail = newMail.toLowerCase();
    const payload = {
      email: newMail,
      password: val.password
    };

    this.store.dispatch(new LogIn(payload));
  } 
}
